import * as Actions from 'actions';
import * as ActionTypes from 'constants';
import { takeEvery, takeLatest } from 'redux-saga';
import { call, put } from 'redux-saga/effects';

import * as Api from 'api';


/***************************** Subroutines ************************************/
function * fetchFields(action) {
  const fields = yield call(Api.fetchFields, action.payload.entity);
  yield put({type : ActionTypes.FETCH_FIELDS_SUCCESS, payload : {fields} });
}

function * fetchField({payload}) {
  const field = yield call(Api.fetchField, action.payload.id);
  yield put({type : ActionTypes.FETCH_FIELD_SUCCESS, payload : {field} });
}

function * createField({payload}) {
  yield put(Actions.sendSocketEmit({field : payload.field}, 'create-field'));
}

function * updateField({payload}) {
  yield put(Actions.sendSocketEmit({field: payload.field}, 'update-field'))
}

function * deleteField({payload}) {
  yield put(Actions.sendSocketEmit({field: payload.field}, 'delete-field'));
}

function * fetchFieldsSuccess({payload}) {
  try {
    const {fields} = payload;
    if(fields) {
      yield put(Actions.addFields(fields));
      // for (var i = fields.length - 1; i >= 0; i--) {
      //   yield put(Actions.addField(fields[i]));
      // };
    }
  }
  catch(ex) {
    console.error(ex);
  }
}

function * fetchFieldSuccess({payload}) {
  try {
    const {field} = payload;
    if(field) {
      console.log('Fetch field success')
      yield put(Actions.addField(field));
    }

  }
  catch(ex) {
    console.error(ex);
  }
}

function* createFieldSuccess(action) {
  yield put(Actions.addField(action.payload.field));
}

function* updateFieldSuccess(action) {
  yield put(Actions.addField(action.payload.field));
}

function* deleteFieldSuccess(action) {
  console.log('Remove field.', action)
  yield put(Actions.removeField(action.payload.field));
}

function * handleFailure(action) {
  yield put(Actions.notify(action.payload));
}

/******************************************************************************/
/******************************* WATCHERS *************************************/
/******************************************************************************/

export function * fieldsWatcher() {
  yield * [
    takeEvery(ActionTypes.CREATE_FIELD_SUCCESS, createFieldSuccess),
    takeEvery(ActionTypes.UPDATE_FIELD_SUCCESS, updateFieldSuccess),
    takeEvery(ActionTypes.DELETE_FIELD_SUCCESS, deleteFieldSuccess),
    takeEvery(ActionTypes.FETCH_FIELDS_SUCCESS, fetchFieldsSuccess),
    takeEvery(ActionTypes.CREATE_FIELD_FAILED, handleFailure),
    takeEvery(ActionTypes.UPDATE_FIELD_FAILED, handleFailure),
    takeEvery(ActionTypes.DELETE_FIELD_FAILED, handleFailure),
    takeEvery(ActionTypes.FETCH_FIELDS_FAILED, handleFailure),
    takeEvery(ActionTypes.FETCH_FIELD_FAILED, handleFailure),
    takeEvery(ActionTypes.FETCH_FIELDS, fetchFields),
    takeEvery(ActionTypes.FETCH_FIELD, fetchField),
    takeEvery(ActionTypes.CREATE_FIELD, createField),
    takeEvery(ActionTypes.UPDATE_FIELD, updateField),
    takeEvery(ActionTypes.DELETE_FIELD, deleteField),
  ]
}



// WEBPACK FOOTER //
// ./src/common/sagas/fields.js